module.exports = __webpack_public_path__ + "0d767d809fb5de89c827446b74108499.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/Foto_Manja_Herrmann-8438.jpg
// module id = 756
// module chunks = 0